import React from 'react';
import { DemoCreditsRow, DemoCreditsLabel, DemoCreditsCount } from './styled';

/**
 * Demo-only credits line: label is plain text; only the remaining count is in a light pill
 * (SciSearch AI header — do not wrap the whole phrase in one pill).
 */
export function NLPDemoCreditsIndicator({ isDemo, remaining }) {
  if (!isDemo) return null;
  if (typeof remaining !== 'number') return null;

  return (
    <DemoCreditsRow data-testid='nlp-demo-credits'>
      <DemoCreditsLabel>Demo searches remaining:</DemoCreditsLabel>
      <DemoCreditsCount>{remaining}</DemoCreditsCount>
    </DemoCreditsRow>
  );
}

export default NLPDemoCreditsIndicator;
